import type { RowData } from '@tanstack/react-table';
import { createContext, useContext } from 'react';

type UpdateFn<TData extends RowData> = (rowId: string, key: keyof TData, value: TData[keyof TData]) => void;

type DataTableContext<TData extends RowData> = {
  updateCell: UpdateFn<TData>;
  columnResizingEnabled: boolean;
  columnOrderingEnabled: boolean;
  setMinColumnSize: (columnId: string, minSize: number) => void;
  resizeColumn: (columnId: string, newSize: number) => void;
  anySelected: boolean;
};

export const DataTableContext = createContext<DataTableContext<RowData> | undefined>(undefined);

export function useDataTableContext<TData extends RowData>(): DataTableContext<TData> {
  const context = useContext(DataTableContext);

  if (!context) {
    throw new Error('useDataTableContext must be used within a DataTableContext provider');
  }

  return context as DataTableContext<TData>;
}
